module.exports = __webpack_public_path__ + "static/media/how_it_works_icon2.b2d21330.png";